import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { AlertCircle, Home, ArrowLeft } from 'lucide-react';

const Error = ({ statusCode = 404, message = 'Page Not Found' }) => {
  return (
    <div className="pt-32 pb-24 px-6 bg-white min-h-screen flex items-center">
      <Helmet>
        <title>Page Not Found | ProjectProse</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div className="max-w-lg mx-auto w-full text-center">
        {/* Error Icon */}
        <div className="mb-8 flex justify-center" data-aos="fade-up">
          <div className="relative">
            <AlertCircle size={120} className="text-prose-gold opacity-20" />
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="text-4xl sm:text-5xl font-display font-bold text-prose-brand">
                {statusCode}
              </span>
            </div>
          </div>
        </div>

        {/* Error Message */}
        <div className="mb-8" data-aos="fade-up" data-aos-delay="100">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-display text-prose-black mb-4">
            {message}
          </h1>
          <p className="text-gray-500 text-sm sm:text-base md:text-lg leading-relaxed">
            Sorry, the page you're looking for doesn't exist or something went wrong. 
            Let's get you back on track.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-aos="fade-up" data-aos-delay="200">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-8 py-3 bg-prose-brand text-white font-semibold rounded-lg hover:bg-prose-brand/90 transition-all duration-300 text-sm sm:text-base"
          >
            <Home size={20} />
            Back to Home
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center gap-2 px-8 py-3 border-2 border-prose-brand text-prose-brand font-semibold rounded-lg hover:bg-prose-brand/5 transition-all duration-300 text-sm sm:text-base"
          >
            <ArrowLeft size={20} />
            Go Back
          </button>
        </div>

        {/* Additional Help */}
        <div className="mt-16 pt-8 border-t border-gray-200" data-aos="fade-up" data-aos-delay="300">
          <p className="text-gray-400 text-sm mb-4">
            Need help? Contact our support team
          </p>
          <Link
            to="/contact"
            className="text-prose-brand font-semibold hover:text-prose-gold transition-colors"
          >
            Get in Touch →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Error;
